import React, { useEffect } from 'react';
import { Stack, TextField, MenuItem, LinearProgress, Box } from '@mui/material';
import { Form, FormikProvider, useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';

import { getAssignableUsers, addAssignProspectLead } from '../../../redux/features/globalSlice';

import useHandleApiResponse from '../../../Hooks/useHandleApiResponse';
import { SubmitButton, CancelButton } from '../../../components/mui/Buttons/Buttons';

export default function LeadAssignUpdate({ row, checkedRowIds = [], onClose }) {
  const dispatch = useDispatch();
  const handleApiResponse = useHandleApiResponse();

  const { AssignedUser, loading } = useSelector((state) => state.global);

  useEffect(() => {
    dispatch(getAssignableUsers());
  }, [dispatch]);

  const initialValues = {
    assignedToNewUserId: row?.current_employee_id || '',
    remarks: '',
  };

  const validationSchema = Yup.object({
    assignedToNewUserId: Yup.number().required('User is required'),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema,

    onSubmit: (values) => {
      const payload = {
        prospectIds: row ? [row.prospect_lead_id] : checkedRowIds,
        assignedToNewUserId: values.assignedToNewUserId,
        remarks: values.remarks,
      };

      dispatch(addAssignProspectLead(payload)).then((res) => {
        handleApiResponse(res, {
          onSuccess: () => {
            onClose(true);
          },
          onFailed: () => {
            console.log('Assign Failed');
          },
        });
      });
    },
  });

  return (
    <FormikProvider value={formik}>
      <Form onSubmit={formik.handleSubmit}>
        <Stack spacing={3} mt={2}>
          {/* Assign User Dropdown */}

          <TextField
            select
            label="Assign To User"
            name="assignedToNewUserId"
            value={formik.values.assignedToNewUserId}
            // value={
            //   AssignedUser.find((u) => u.userID === formik.values.assignedToNewUserId)
            //     ? formik.values.assignedToNewUserId
            //     : ''
            // }
            onChange={formik.handleChange}
            fullWidth
          >
            {AssignedUser.map((user) => (
              <MenuItem key={user.userID} value={user.userID}>
                {user.name}
              </MenuItem>
            ))}
          </TextField>

          {/* Remarks */}

          <TextField
            label="Remarks"
            name="remarks"
            multiline
            rows={3}
            value={formik.values.remarks}
            onChange={formik.handleChange}
            fullWidth
          />

          {/* Buttons */}
          {loading && (
            <Box sx={{ width: '100%' }}>
              <LinearProgress />
            </Box>
          )}

          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <CancelButton action={() => onClose(false)}>Cancel</CancelButton>

            <SubmitButton disabled={loading} type="submit">
              {loading ? 'Assigning...' : 'Assign'}
            </SubmitButton>
          </Stack>
        </Stack>
      </Form>
    </FormikProvider>
  );
}
